import React, { Component } from 'react';
import { Card, CardImg, CardText, CardBody,
    CardTitle, Breadcrumb, BreadcrumbItem,
    Nav, NavItem, Button, Modal, ModalHeader,
    ModalBody, Label, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Loading } from './LoadingComponent';
import { CreateParagraphs } from './ReviewdetailComponent.js';
import Chess from './ChessComponent';
import ChessControls from './ChessControlsComponent';

    const ShowSimulBoards = function  (props) {
        return (
          <div>
            {props.games.map((game,key) => {

                let index = props.index < Object.keys(props.games[game.id].diagrams).length ? props.index : Object.keys(props.games[game.id].diagrams).length - 1;
                let comment = index > 0 ? game.comments[index] : "";
                return (
                  <div key={key}>
                    <Chess fen={props.games[game.id].diagrams[index]} squareColor={props.squareColor} pieceType={props.pieceType}/>
                    <div>{game.comments[0]}</div>
                    <div>{comment}</div>
                  </div>
                );
            })}
          </div>);
    }

// todo: still trying to get this to work. Trying to show one move at a time on each simul board
    class ShowSimulBoardsNew extends React.Component{
      constructor(props) {
         super(props);

         this.state = { lastGame: 0};
      }

      componentDidUpdate() {
        this.timer = setInterval(() => {
            if(this.state.lastGame >= this.props.games.length) {
                clearInterval(this.timer);
                this.setState({lastGame : 0});
                return
            }

            this.setState(prevState => {
                return {
                    lastGame : prevState.lastGame + 1
                }
            });
        }, 5000);
        console.log("Component mounted. Last game: " + this.state.lastGame)
	     }

      render(){
        let games = this.props.games;
        let stop = this.state.lastGame;
        let iCount = 0;
        console.log("Last game: " + this.state.lastGame)
        return (
          <div>
            {games.map((game,key) => {

                let index = this.props.index < Object.keys(games[game.id].diagrams).length ? this.props.index : Object.keys(games[game.id].diagrams).length - 1;
                if(index > 0)
                {
                  index = iCount <= stop ? index : index - 1;
                }
                iCount++;
                let comment = index > 0 ? game.comments[index] : "";
                console.log("Index: " + index)
                return (
                  <div key={key}>
                    <Chess fen={games[game.id].diagrams[index]} squareColor={this.props.squareColor} pieceType={this.props.pieceType}/>
                    <div>{game.comments[0]}</div>
                    <div>{comment}</div>
                  </div>
                );
            })}
          </div>);
      }
    }

    class SimulDetail extends React.Component{
      constructor(props) {
         super(props);

         this.state = { index: 0, squareColor: 'green', pieceType: 'image', gameIndex: 0};

      }

    getPrevious(id, max, min){
      if(id == min){
        return max;
      }
      return id - 1;
    }

    getNext(id, max, min){
      if(id == max){
        return min;
      }
      return id + 1;
    }

    updateStateIndexFromChild = (index) => {
      this.setState({
        index,
        gameIndex: 0
      })
      // todo: setInterval(this.nextGame, 2000);
    }

    nextGame = () => {
      if(Object.keys(this.props.simul.games).length > (this.state.gameIndex + 1))
      {
         this.setState({gameIndex : this.state.gameIndex + 1});
      }
    }

    updateStateColorFromChild = (squareColor) => {
      this.setState({
        squareColor
      })
    }

    updateStatePieceTypeFromChild = (pieceType) => {
      this.setState({
        pieceType
      })
    }

      render(){
        if (this.props.isLoading) {
            return(
                <div className="container">
                    <div className="row">
                        <Loading />
                    </div>
                </div>
            );
        }
        else if (this.props.errMess) {
            return(
                <div className="container">
                    <div className="row">
                        <h4>{this.props.errMess}</h4>
                    </div>
                </div>
            );
        }
        else if(this.props.simul != null)
        {
                return (
                <div className="container">
                <div className="row">
                    <Link to={`/simuls/${this.getPrevious(this.props.simul.id, this.props.max, this.props.min)}`}>
                      <button class="btn btn-primary">
                         Previous Simul
                      </button>
                    </Link>
                    <Breadcrumb>
                        <BreadcrumbItem><Link to="/simuls">Simuls</Link></BreadcrumbItem>
                        <BreadcrumbItem active>{this.props.simul.name}</BreadcrumbItem>
                    </Breadcrumb>
                    <Link to={`/simuls/${this.getNext(this.props.simul.id, this.props.max, this.props.min)}`}>
                      <button class="btn btn-primary">
       		               Next Simul
       		            </button>
                    </Link>
                    <div className="col-12">
                        <h3>{this.props.simul.name}</h3>
                        <hr />
                    </div>
                </div>
                <div className="row">
                    <div>
                        <CreateParagraphs description={this.props.simul.description}/>
                    </div>
                </div>
                <ChessControls update={this.props.simul.games[this.state.gameIndex]} updateStateIndexFromChild = {this.updateStateIndexFromChild} updateStateColorFromChild = {this.updateStateColorFromChild} updateStatePieceTypeFromChild = {this.updateStatePieceTypeFromChild} showPartial = {true} />
                <div className="row">
                  <div className="col-12 col-md m-1">
                    <ShowSimulBoards games={this.props.simul.games} squareColor={this.state.squareColor} pieceType={this.state.pieceType} gameIndex={this.state.gameIndex} index={this.state.index}/>
                  </div>
                </div>
                </div>
            );
        }
        else
		return (
		   <div></div>
		);
      }
    }

export default SimulDetail;
